
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 245","d":"M50.91 46.69L57.67 60c1.33 2.62-2.16 5.11-4.81 3.41L33.18 50.82 7.36 34.27a2.62 2.62 0 01-1-3.58 2.68 2.68 0 011-1l25.82-16.52L52.87.56c2.64-1.7 6.13.78 4.8 3.44l-6.76 13.34a32.13 32.13 0 000 29.35z"}})])
          )
        }
      }
    